import script from "./PRO_ComenziView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PRO_ComenziView.vue?vue&type=script&lang=ts&setup=true"

import "./PRO_ComenziView.vue?vue&type=style&index=0&id=76f86a80&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76f86a80"]])

export default __exports__